'use client';
import { useRef } from 'react';
import { Carousel, type CarouselProps } from '@/components/carousel/Carousel';
import analytics from '@/services/analytics';

export type RecentSearchesBlockProps = CarouselProps;

export function RecentSearchesCarousel({ children, onSelect, ...props }: RecentSearchesBlockProps) {
    const prevIndexRef = useRef(0);
    return (
        <Carousel
            {...props}
            onSelect={(emblaApi) => {
                const nextIndex = emblaApi.selectedScrollSnap();
                const prevIndex = prevIndexRef.current;
                const direction = nextIndex > prevIndex ? 'next' : 'prev';
                analytics.plugins.interactions.trackInteraction({
                    source: 'jucy-website',
                    category: 'recent-search',
                    action: 'slide',
                    label: `Show ${direction}`,
                });
                prevIndexRef.current = nextIndex;
                onSelect?.(emblaApi);
            }}
        >
            {children}
        </Carousel>
    );
}
